import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "./pages/Common/Common_css/Form_css/Form_css.css";
import "./pages/Common/Common_css/Btn_css/Btn_css.css";
import "./pages/Common/Common_css/Modal_css/Modal_css.css";
import "./pages/Common/Common_css/Swiper_css/Swiper_css.css";
import "./pages/Common/Common_css/Offcanvas_css/Offcanvas_css.css";

import SplashOne from "./pages/SpashScreen/SplashOne";
import Login from "./pages/Auth/Login/Login";
import SignUp from "./pages/Auth/SignUp/SignUp";
import Forget_password from "./pages/Auth/Forget_password/Forget_password";
import Header from "./pages/Header/Header";
import Footer from "./pages/Footer/Footer";
import Home from "./pages/Home/Home";
import AppLayout from "./layout/AppLayout";
import Notifications from "./pages/Notifications/Notifications";
import Play_Now_Game from "./pages/Play_Now_Game/Play_Now_Game";
import Withdraw from "./pages/Withdraw/Withdraw";
import Deposite from "./pages/Deposite/Deposite";
import Bank_Account from "./pages/Bank_Account/Bank_Account";
import Add_Bank_Account from "./pages/Add_Bank_Account/Add_Bank_Account";
import Withdrawal_History_List from "./pages/Withdrawal_History_List/Withdrawal_History_List";
import Deposite_History_List from "./pages/Deposite/Deposite_History_List/Deposite_History_List";
import Self_Service_Center from "./pages/Self_Service_Center/Self_Service_Center";
import Activity from "./pages/Activity/Activity";
import Invitation_Bonus from "./pages/Invitation_Bonus/Invitation_Bonus";
import Invitation_Reward_Rules from "./pages/Invitation_Reward_Rules/Invitation_Reward_Rules";
import Invitation_Record from "./pages/Invitation_Record/Invitation_Record";
import Betting_Rebate from "./pages/Betting_Rebate/Betting_Rebate";
import Betting_Rebate_History from "./pages/Betting_Rebate_History/Betting_Rebate_History";
import Agency from "./pages/Agency/Agency";
import Invitation_Rules from "./pages/Invitation_Rules/Invitation_Rules";
import Account from "./pages/Account/Account";
import Subordinate_Data from "./pages/Subordinate_Data/Subordinate_Data";
import Commission_Details from "./pages/Commission_Details/Commission_Details";
import Rebate_Ratio from "./pages/Rebate_Ratio/Rebate_Ratio";
import Invite from "./pages/Invite/Invite";
import Confidentiality_Agreement from "./pages/Confidentiality_Agreement/Confidentiality_Agreement";
import Announcement from "./pages/Announcement/Announcement";
import About_Us from "./pages/About_Us/About_Us";
import Risk_Disclosure_Agreement from "./pages/Risk_Disclosure_Agreement/Risk_Disclosure_Agreement";
import Transaction_History from "./pages/Transaction_History/Transaction_History";
import Game_History from "./pages/Game_History/Game_History";
import Gift from "./pages/Gift/Gift";
import Game_Statistics from "./pages/Game_Statistics/Game_Statistics";
import Setting_Center from "./pages/Setting_Center/Setting_Center";
import Change_Login_Password from "./pages/Change_Login_Password/Change_Login_Password";
import Bind_Mailbox from "./pages/Bind_Mailbox/Bind_Mailbox";
import Feedback from "./pages/Feedback/Feedback";
import Beginner_Guide from "./pages/Beginner_Guide/Beginner_Guide";
import Payment_Method from "./pages/Payment_Method/Payment_Method";
import Add_Payment_Method from "./pages/Payment_Method/Add_Payment_Method/Add_Payment_Method";
import Bonus_Details from "./pages/Bonus_Details/Bonus_Details";
import Wheel_Cash_Out_History from "./pages/Wheel_Cash_Out_History/Wheel_Cash_Out_History";
import Invite_Wheel from "./pages/Invite_Wheel/Invite_Wheel";
import Wallet from "./pages/Wallet/Wallet";
import { Context } from "./utils/context";
import { useContext, useState } from "react";
import IFSC_Modification from "./pages/IFSC_Modification/IFSC_Modification";
import Change_Bank_Name from "./pages/Change_Bank_Name/Change_Bank_Name";
import Modify_Bank_Information from "./pages/Modify_Bank_Information/Modify_Bank_Information";
import Modify_UPI from "./pages/Modify_UPI/Modify_UPI";
import Add_USDT_Address from "./pages/Add_USDT_Address/Add_USDT_Address";
import Change_USDT_Address from "./pages/Change_USDT_Address/Change_USDT_Address";
import Activity_Bonus from "./pages/Activity_Bonus/Activity_Bonus";
import Deposit_Not_Received from "./pages/Deposit_Not_Received/Deposit_Not_Received";
import Deposit_Not_Received_Form from "./pages/Deposit_Not_Received/Deposit_Not_Received_Form/Deposit_Not_Received_Form";
import Withdrawl_Problem from "./pages/Withdrawl_Problem/Withdrawl_Problem";
import Self_Service_Change_Password from "./pages/Self_Service_Change_Password/Self_Service_Change_Password";
import Change_Password from "./pages/Change_Password/Change_Password";
import Progress_Query from "./pages/Progress_Query/Progress_Query";
import Withdrawl_Problem_List from "./pages/Withdrawl_Problem_List/Withdrawl_Problem_List";
import Vip from "./pages/Vip/Vip";
import Vip_history from "./pages/Vip/Vip_details_history/Vip_details_history";
import Vip_details_history from "./pages/Vip/Vip_details_history/Vip_details_history";
import Vip_all_history from "./pages/Vip_all_history/Vip_all_history";
import Turntable from "./pages/Turntable/Turntable";
import { useNavigate } from "react-router-dom";
import Turntable_Activity_Rules from "./pages/Turntable/Turntable_Activity_Rules/Turntable_Activity_Rules";
import Turntable_Activity_details from "./pages/Turntable/Turntable_Activity_details/Turntable_Activity_details";
import Turntable_Event_Description from "./pages/Turntable/Turntable_Event_Description/Turntable_Event_Description";
import ScrollToTop from "./pages/Common/Common_Component/ScrollTotop/ScrollTotop";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const hideFloatRoutes = ["/home"];
  const shouldHideFloat = !hideFloatRoutes.includes(location.pathname);
  // Routes where Header should be hidden
  const hideHeaderRoutes = ["/home"];

  // Routes where Footer should be hidden
  const hideFooterRoutes = [
    "/",
    "/login",
    "/sign-up",
    "/forgot-password",
    "/play-now-game",
    "/withdraw",
    "/bank-account",
    "/add-bank-account",
    "/game-history",
    "/withdrawal-history",
    "/deposite",
    "/deposite-history",
    "/self-service-center",
    "/invitation-bonus",
    "/invitation-record",
    "/betting-rebate",
    "/invite-wheel",
    "/ifsc-modification",
    "/change-bank-name",
    "/modify-bank-information",
    "/modify-upi",
    "/add-usdt-address",
    "/change-usdt-address",
    "/activity-bonus",
    "/vip-details-history",
    "/vip-all-history",
    "/turntable",
    "/activity-rules",
    "/activity-details",
    "/event-description",
    "/progress-query",
    "/deposit-not-received",
    "/withdrawal-problem-list",
    "/change-login-password",
    "/about-us",
    "/confidentiality-agreement",
    "/risk-disclosure-agreement",
    "/beginners-guide",
  ];

  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);
  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <div>
      <AppLayout>
        {shouldHideHeader && <Header />}
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<SplashOne />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/forgot-password" element={<Forget_password />} />
          <Route path="/home" element={<Home />} />
          <Route path="/play-now-game" element={<Play_Now_Game />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/bank-account" element={<Bank_Account />} />
          <Route path="/add-bank-account" element={<Add_Bank_Account />} />
          <Route
            path="/withdrawal-history"
            element={<Withdrawal_History_List />}
          />
          <Route path="/deposite" element={<Deposite />} />
          <Route path="/deposite-history" element={<Deposite_History_List />} />
          <Route
            path="/self-service-center"
            element={<Self_Service_Center />}
          />
          <Route path="/activity" element={<Activity />} />
          <Route path="/invitation-bonus" element={<Invitation_Bonus />} />
          <Route
            path="/invitation-reward-rules"
            element={<Invitation_Reward_Rules />}
          />
          <Route path="/invitation-record" element={<Invitation_Record />} />
          <Route path="/betting-rebate" element={<Betting_Rebate />} />
          <Route
            path="/betting-rebate-history"
            element={<Betting_Rebate_History />}
          />
          <Route path="/invitation-rules" element={<Invitation_Rules />} />
          <Route path="/promotion" element={<Agency />} />
          <Route path="/subordinate-data" element={<Subordinate_Data />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/commission-details" element={<Commission_Details />} />
          <Route path="/rebate-ratio" element={<Rebate_Ratio />} />
          <Route path="/account" element={<Account />} />
          <Route path="/announcement" element={<Announcement />} />
          <Route path="/about-us" element={<About_Us />} />
          <Route
            path="/confidentiality-agreement"
            element={<Confidentiality_Agreement />}
          />
          <Route
            path="/risk-disclosure-agreement"
            element={<Risk_Disclosure_Agreement />}
          />
          <Route
            path="/transaction-history"
            element={<Transaction_History />}
          />
          <Route path="/game-history" element={<Game_History />} />
          <Route path="/gift" element={<Gift />} />
          <Route path="/game-statistics" element={<Game_Statistics />} />
          <Route path="/setting-center" element={<Setting_Center />} />
          <Route path="/change-password" element={<Change_Login_Password />} />
          <Route path="/bind-mailbox" element={<Bind_Mailbox />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/beginners-guide" element={<Beginner_Guide />} />
          <Route path="/payment-method" element={<Payment_Method />} />
          <Route path="/add-payment-method" element={<Add_Payment_Method />} />
          <Route path="/bonus-details" element={<Bonus_Details />} />
          <Route path="/invite-wheel" element={<Invite_Wheel />} />
          <Route
            path="/wheel-cash-out-history"
            element={<Wheel_Cash_Out_History />}
          />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/ifsc-modification" element={<IFSC_Modification />} />
          <Route path="/change-bank-name" element={<Change_Bank_Name />} />
          <Route
            path="/modify-bank-information"
            element={<Modify_Bank_Information />}
          />
          <Route path="/modify-upi" element={<Modify_UPI />} />
          <Route path="/add-usdt-address" element={<Add_USDT_Address />} />
          <Route
            path="/change-usdt-address"
            element={<Change_USDT_Address />}
          />
          <Route path="/activity-bonus" element={<Activity_Bonus />} />
          <Route
            path="/deposit-not-received"
            element={<Deposit_Not_Received />}
          />
          <Route
            path="/deposit-not-received-form/:id"
            element={<Deposit_Not_Received_Form />}
          />
          <Route
            path="/withdrawal-problem/:id"
            element={<Withdrawl_Problem />}
          />
          <Route
            path="/withdrawal-problem-list"
            element={<Withdrawl_Problem_List />}
          />
          <Route
            path="/self-service-change-password"
            element={<Self_Service_Change_Password />}
          />
          <Route path="/change-login-password" element={<Change_Password />} />
          <Route path="/progress-query" element={<Progress_Query />} />

          <Route path="/vip" element={<Vip />} />
          <Route
            path="/vip-details-history"
            element={<Vip_details_history />}
          />
          <Route path="/vip-all-history" element={<Vip_all_history />} />

          <Route path="/turntable" element={<Turntable />} />
          <Route
            path="/activity-rules"
            element={<Turntable_Activity_Rules />}
          />
          <Route
            path="/activity-details"
            element={<Turntable_Activity_details />}
          />
          <Route
            path="/event-description"
            element={<Turntable_Event_Description />}
          />
        </Routes>

        {!shouldHideFooter && <Footer />}
      </AppLayout>
      {!shouldHideFloat && (
        <div className="float_tab_holder">
          <div
            className="img_holder"
            onClick={() => navigate("/turntable")}
            style={{ cursor: "pointer" }}
          >
            <img
              className="float_img"
              src="/assets/images/wheel/wheel.png"
              alt="Floating Tab"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
